"use client";

import { c as _c } from "react/compiler-runtime";
import { forwardRef, useEffect, useRef, type ReactNode } from "react";
import gsap from "gsap";
type Props = {
  children: ReactNode;
  onClick?: () => void;
  href?: string;
  className?: string;
  label?: string;
};
export const MagneticButton = forwardRef<HTMLElement, Props>(function MagneticButton(t0, ref) {
  const $ = _c(21);
  const {
    children,
    onClick,
    href,
    className: t1,
    label
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const localRef = useRef(null);
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      if (typeof window === "undefined") {
        return;
      }
      if (window.matchMedia("(pointer: coarse)").matches) {
        return;
      }
      const el = localRef.current;
      if (!el) {
        return;
      }
      const onMove = e => {
        const r = el.getBoundingClientRect();
        const cx = r.left + r.width / 2;
        const cy = r.top + r.height / 2;
        const dx = (e.clientX - cx) * 0.35;
        const dy = (e.clientY - cy) * 0.35;
        gsap.to(el, {
          x: dx,
          y: dy,
          duration: 0.5,
          ease: "power3.out"
        });
      };
      const onLeave = () => {
        gsap.to(el, {
          x: 0,
          y: 0,
          duration: 0.9,
          ease: "elastic.out(1, 0.4)"
        });
      };
      el.addEventListener("pointermove", onMove);
      el.addEventListener("pointerleave", onLeave);
      return () => {
        el.removeEventListener("pointermove", onMove);
        el.removeEventListener("pointerleave", onLeave);
        gsap.killTweensOf(el);
      };
    };
    t3 = [];
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  useEffect(t2, t3);
  let t4;
  if ($[2] !== ref) {
    t4 = node => {
      localRef.current = node;
      if (typeof ref === "function") {
        ref(node);
      } else {
        if (ref) {
          (ref as React.MutableRefObject<HTMLElement | null>).current = node;
        }
      }
    };
    $[2] = ref;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const assign = t4;
  if (href) {
    let t5;
    if ($[4] !== assign) {
      t5 = n => assign(n as HTMLElement | null);
      $[4] = assign;
      $[5] = t5;
    } else {
      t5 = $[5];
    }
    const t6 = `l2-magnet ${className}`;
    let t7;
    if ($[6] !== children || $[7] !== href || $[8] !== label || $[9] !== onClick || $[10] !== t5 || $[11] !== t6) {
      t7 = <a ref={t5} href={href} onClick={onClick} className={t6} data-cursor={label}>{children}</a>;
      $[6] = children;
      $[7] = href;
      $[8] = label;
      $[9] = onClick;
      $[10] = t5;
      $[11] = t6;
      $[12] = t7;
    } else {
      t7 = $[12];
    }
    return t7;
  }
  let t5;
  if ($[13] !== assign) {
    t5 = n_0 => assign(n_0 as HTMLElement | null);
    $[13] = assign;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const t6 = `l2-magnet ${className}`;
  let t7;
  if ($[15] !== children || $[16] !== label || $[17] !== onClick || $[18] !== t5 || $[19] !== t6) {
    t7 = <button ref={t5} onClick={onClick} className={t6} data-cursor={label} type="button">{children}</button>;
    $[15] = children;
    $[16] = label;
    $[17] = onClick;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
});